import styled from "styled-components";

export const SubmitReqStyled = styled.div`
  height: 100%;
  max-width: 650px;
  /* min-width: 600px; */
  margin: auto;

  display: flex;
  align-items: center;
  justify-content: space-between;

  & > div {
    flex-basis: 48%;
  }
`;
